import React from 'react';
import { FormattedMessage } from 'react-intl';

import { IllustrationEmptyStateSuitcase } from '@xingternal/illustrations';

import { useBreakpoints } from '@/hooks/use-breakpoints';

import { AlertButton } from '../../../alert-button';

import * as S from './empty-banner.styles';

export const EmptyBanner: React.VFC = () => {
  const { isMobile } = useBreakpoints();

  return (
    <S.ContentBanner noPadding display="inline">
      <IllustrationEmptyStateSuitcase size="large" />
      <S.TextContainer>
        <S.Headline size="xxlarge" noMargin>
          <FormattedMessage id="JOBS_SEARCH_EMPTY_STATE_EXPLAINER_HEADLINE_ALTERNATE" />
        </S.Headline>
        <S.Meta noMargin>
          <FormattedMessage id="JOBS_SEARCH_EMPTY_STATE_EXPLAINER_PARAGRAPH" />
        </S.Meta>
      </S.TextContainer>
      <AlertButton variant="tertiary" showIcon={!isMobile} propActionOrigin="jobs_serp_empty_state_button" />
    </S.ContentBanner>
  );
};
